export default __webpack_public_path__ + "b65254fea80c5e67acf9a2ceee6ab14f.svg";